import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import {
  colorsPalette,
  INNER_BOTTOM_SPACE_DESK,
  LARGE_MARGIN,
  MIDDLE_MARGIN,
  SMALL_MARGIN,
} from '../../theme';

const useStyles = (background, video, highlightColor) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: video ? 650 : 0,
        background: theme.palette.secondary.dark,
        zIndex: 0,

        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: 476,
          maxHeight: '100%',
          backgroundColor: 'transparent',
          background:
            'linear-gradient(180deg, #1B1925 0%, rgba(27, 25, 37, 0) 100%) 0% 0% no-repeat',
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
          zIndex: 3,
        },

        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: -1,
          left: 0,
          width: '100%',
          height: 242,
          backgroundColor: 'transparent',
          background: 'linear-gradient(0deg, #1B1925 0%, rgba(27, 25, 37, 0) 100%) 0% 0% no-repeat',
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
          zIndex: 3,
        },

        [theme.breakpoints.up('md')]: {
          height: video ? '80vh' : 'auto',
          maxHeight: video ? 900 : 'none',
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
          '&::before': {
            width: '70%',
            height: '101%',
            backgroundColor: 'transparent',
            background:
              'linear-gradient(90deg, #1B1925 0%, rgba(27, 25, 37, 0) 100%) 0% 0% no-repeat',
            '-webkit-background-origin': 'padding-box',
            '-o-background-origin': 'padding-box',
            '-moz-background-origin': 'padding-box',
          },
          '&::after': {
            display: 'none',
          },
        },
      },
      img: {
        position: 'absolute',
        bottom: '0%',
        left: '50%',
        transform: 'translate(-50%, 0%)',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
      },
      container: {
        paddingTop: video ? 0 : 160,
        paddingBottom: video ? 0 : 90,
        zIndex: 4,
      },
      smallPadding: {
        paddingTop: 160,
        paddingBottom: 60,
      },
      textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        [theme.breakpoints.up('md')]: {
          maxWidth: 435,
        },
      },
      title: {
        marginBottom: SMALL_MARGIN,
        textAlign: 'left',
        [theme.breakpoints.up('md')]: {
          marginBottom: MIDDLE_MARGIN,
        },
        '& span': {
          color: highlightColor || colorsPalette.primary,
        },
      },
      smallMargin: {
        marginBottom: 20,
      },
      subTitle: {
        fontSize: 18,
        lineHeight: '24px',
        marginBottom: 22,
        width: '100%',
        textAlign: 'left',
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          lineHeight: 1.5,
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
        [theme.breakpoints.between('sm', 'lg')]: {
          maxWidth: 600,
        },
      },
      newSubtitle: {
        color: colorsPalette.gray,
        lineHeight: 1.5,
        fontSize: 18,
        maxWidth: 620,
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
        },
      },
      playBtn: {
        marginBottom: MIDDLE_MARGIN,
        '&:hover': {
          borderBottomColor: 'transparent',
        },
      },
      playIcon: {
        width: 24,
        height: 24,
      },
      playBtnDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          cursor: 'pointer',
          display: 'block',
          position: 'absolute',
          width: '52px',
          height: '60px',
          left: 'calc(50% - 26px)',
          top: 'calc(50% - 30px)',
          transform: 'translate(-50%, -50%)',
          fontSize: '80px',
          zIndex: 4,
          animation: 'pulse-white 2s infinite',
        },
      },
      customBtn: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: 'unset',
        },
      },
      gradient: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'radial-gradient(at center, #6667ef 0%, #7cfef1 100%)',
        transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s;',
        opacity: 0.3,
        [theme.breakpoints.up('md')]: {
          backgroundImage: 'radial-gradient(at center left, #6667ef 0%, #7cfef1 100%)',
        },
      },
      topGradient: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 300,
        background:
          'transparent linear-gradient(180deg, #1B1925 0%, rgba(27, 25, 37, 0) 100%) 0% 0% no-repeat padding-box;',
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      bottomGradient: {
        position: 'absolute',
        bottom: -1,
        left: 0,
        width: '100%',
        height: 373,
        background:
          'transparent linear-gradient(0deg, #1B1925 0%, rgba(27, 25, 37, 0) 100%) 0% 0% no-repeat padding-box;',
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      previewVideo: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'block',
          position: 'absolute',
          maxWidth: '100%',
          maxHeight: '100%',
          minWidth: '100%',
          minHeight: '100%',
          right: '50%',
          width: 'auto',
          height: 'auto',
          top: 0,
          bottom: 0,
          left: 0,
          objectFit: 'cover',
          opacity: 1,
          transition: 'opacity 1s ease',
        },
      },
      hide: {
        opacity: 0,
      },
      bottomItemsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('sm')]: {
          marginBottom: LARGE_MARGIN,
        },
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
        },
      },
      bottomItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        marginBottom: MIDDLE_MARGIN,
        '&:last-child': {
          marginBottom: 0,
        },
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          maxWidth: 240,
          marginRight: MIDDLE_MARGIN,
          '&:last-child': {
            marginRight: 0,
          },
        },
      },
      bottomItemImageWrapper: {
        width: 40,
        marginBottom: SMALL_MARGIN / 2,
        [theme.breakpoints.up('md')]: {
          width: 65,
          marginBottom: 0,
          marginRight: SMALL_MARGIN,
        },
      },
      bottomItemImg: {
        width: '100%',
      },
      bottomItemText: {},
    }),
  );
export default useStyles;
